// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"723":"3498a312","782":"1ceaa51e"}[chunkId] + ".chunk.css";
};